const k = {
  host: "",
  basePath: "/api/v1.0",
  authToken: ""
};
function f(o) {
  return {
    get: async (s = {}) => await b(o, "GET", {}, s),
    post: async (s = {}, p = {}) => await b(o, "POST", s, p),
    put: async (s = {}, p = {}) => await b(o, "PUT", s, p),
    patch: async (s = {}, p = {}) => await b(o, "PATCH", s, p),
    head: async (s = {}) => await b(o, "HEAD", {}, s),
    del: async (s = {}, p = {}) => await b(o, "DELETE", s, p)
  };
}
async function b(o, c, n = {}, t = {}) {
  return new Promise(async (e, u) => {
    const r = await fetch(o, {
      method: c,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${k.authToken}`,
        ...t
      },
      body: c === "GET" ? void 0 : JSON.stringify(n)
    }).catch((s) => {
      u(s);
    });
    if (!r)
      return u("No response");
    if (!r.ok)
      return u(r);
    try {
      const s = await r.json();
      e(s);
    } catch {
      e(!0);
    }
  });
}
function D(o, c, n) {
  const t = `${o}${c}/${n}/account`;
  function e() {
    return f(t).get();
  }
  return { get: e };
}
function S(o, c, n) {
  const t = `${o}${c}/${n}`;
  function e() {
    return f(t).get();
  }
  return { get: e };
}
function W(o, c) {
  const n = `${o}${c}/domains`;
  function t() {
    return f(n).get();
  }
  return { get: t };
}
function N(o, c, n) {
  const t = `${o}${c}/${n}/members`;
  function e() {
    return f(t).get();
  }
  function u(s) {
    return f(t).post(s);
  }
  function r(s) {
    return f(t).del(s);
  }
  return { get: e, post: u, del: r };
}
function O(o, c, n) {
  const t = `${o}${c}/${n}/searchUsers`;
  function e(u) {
    return f(`${t}?query=${u}`).get();
  }
  return { get: e };
}
function A(o, c, n) {
  const t = `${o}${c}/${n}/graph`;
  function e(r) {
    return f(t + "/" + r).get();
  }
  function u(r) {
    return f(t).patch(r);
  }
  return { get: e, patch: u };
}
function L(o, c, n) {
  const t = `${o}${c}/${n}/descriptor/datatypes`;
  function e() {
    return f(t).get();
  }
  return { get: e };
}
function J(o, c, n, t) {
  const e = `${o}${c}/${n}/descriptor/datatype/${t}`;
  function u() {
    return f(e).get();
  }
  function r(p) {
    return f(e).put(p);
  }
  function s() {
    return f(e).del();
  }
  return { get: u, put: r, del: s };
}
function U(o, c, n) {
  const t = `${o}${c}/${n}/concept/attributes`;
  function e() {
    return f(t).get();
  }
  return { get: e };
}
function F(o, c, n, t) {
  const e = `${o}${c}/${n}/concept/attribute/${t}`;
  function u() {
    return f(e).get();
  }
  return { get: u };
}
function G(o, c, n) {
  const t = `${o}${c}/${n}/concept/events`;
  function e() {
    return f(t).get();
  }
  function u(r) {
    return f(t).post(r);
  }
  return { get: e, post: u };
}
function H(o, c, n, t) {
  const e = `${o}${c}/${n}/concept/event/${t}`;
  function u() {
    return f(e).get();
  }
  function r(p) {
    return f(e).put(p);
  }
  function s() {
    return f(e).del();
  }
  return { get: u, del: s, put: r };
}
function R(o, c, n) {
  const t = `${o}${c}/${n}/concept/tasks`;
  function e() {
    return f(t).get();
  }
  return { get: e };
}
function d(o, c, n, t) {
  const e = `${o}${c}/${n}/concept/task/${t}`;
  function u() {
    return f(e).get();
  }
  return { get: u };
}
function q(o, c, n) {
  const t = `${o}${c}/${n}/concept/dataobjects`;
  function e() {
    return f(t).get();
  }
  return { get: e };
}
function x(o, c, n, t) {
  const e = `${o}${c}/${n}/concept/dataobject/${t}`;
  function u() {
    return f(e).get();
  }
  return { get: u };
}
function z(o, c, n) {
  const t = `${o}${c}/${n}/concept/fragments`;
  function e() {
    return f(t).get();
  }
  return { get: e };
}
function B(o, c, n, t) {
  const e = `${o}${c}/${n}/concept/fragment/${t}`;
  function u() {
    return f(e).get();
  }
  return { get: u };
}
function M(o, c, n) {
  const t = `${o}${c}/${n}/concept/functions`;
  function e() {
    return f(t).get();
  }
  return { get: e };
}
function K(o, c, n, t) {
  const e = `${o}${c}/${n}/concept/function/${t}`;
  function u() {
    return f(e).get();
  }
  return { get: u };
}
function Q(o, c, n) {
  const t = `${o}${c}/${n}/concept/emitters`;
  function e() {
    return f(t).get();
  }
  return { get: e };
}
function V(o, c, n, t) {
  const e = `${o}${c}/${n}/concept/emitter/${t}`;
  function u() {
    return f(e).get();
  }
  return { get: u };
}
function X(o, c, n) {
  const t = `${o}${c}/${n}/template/events`;
  function e() {
    return f(t).get();
  }
  function u(r) {
    return f(t).post(r);
  }
  return { get: e, post: u };
}
function Y(o, c, n, t) {
  const e = `${o}${c}/${n}/template/event/${t}`;
  function u() {
    return f(e).get();
  }
  function r(p) {
    return f(e).put(p);
  }
  function s() {
    return f(e).del();
  }
  return { get: u, put: r, del: s };
}
function Z(o, c, n) {
  const t = `${o}${c}/${n}/template/tasks`;
  function e() {
    return f(t).get();
  }
  function u(r) {
    return f(t).post(r);
  }
  return { get: e, post: u };
}
function _(o, c, n, t) {
  const e = `${o}${c}/${n}/template/task/${t}`;
  function u() {
    return f(e).get();
  }
  function r(p) {
    return f(e).put(p);
  }
  function s() {
    return f(e).del();
  }
  return { get: u, put: r, del: s };
}
function w(o, c, n) {
  const t = `${o}${c}/${n}/template/dataobjects`;
  function e() {
    return f(t).get();
  }
  function u(r) {
    return f(t).post(r);
  }
  return { get: e, post: u };
}
function I(o, c, n, t) {
  const e = `${o}${c}/${n}/template/dataobject/${t}`;
  function u() {
    return f(e).get();
  }
  function r(p) {
    return f(e).put(p);
  }
  function s() {
    return f(e).del();
  }
  return { get: u, put: r, del: s };
}
function tt(o, c, n) {
  const t = `${o}${c}/${n}/template/processes`;
  function e() {
    return f(t).get();
  }
  function u(r, s, p, g, v, E) {
    return f(t).post({ conceptDataobjectId: r, name: s, description: p, tags: g, password: v, language: E });
  }
  return { get: e, post: u };
}
function et(o, c, n, t) {
  const e = `${o}${c}/${n}/template/process/${t}`;
  function u() {
    return f(e).get();
  }
  function r(g) {
    return f(e).put(g);
  }
  function s() {
    return f(e).del();
  }
  function p(g) {
    return f(e + "/duplicate").post({ templateDataobjectId: g });
  }
  return { get: u, put: r, del: s, duplicate: p };
}
function nt(o, c, n, t) {
  const e = `${o}${c}/${n}/template/process/${t}/password`;
  function u() {
    return f(e).get();
  }
  function r(p) {
    return f(e).post({ password: p });
  }
  function s(p) {
    return f(e).put({ password: p });
  }
  return { get: u, post: r, put: s };
}
function ot(o, c, n) {
  const t = `${o}${c}/${n}/template/workspaces`;
  function e() {
    return f(t).get();
  }
  function u(r, s, p, g, v) {
    return f(t).post({ name: r, description: s, tags: p, password: g, language: v });
  }
  return { get: e, post: u };
}
function ct(o, c, n, t) {
  const e = `${o}${c}/${n}/template/workspace/${t}`;
  function u() {
    return f(e).get();
  }
  function r(p) {
    return f(e).put(p);
  }
  function s() {
    return f(e).del();
  }
  return { get: u, put: r, del: s };
}
function ut(o, c, n, t) {
  const e = `${o}${c}/${n}/template/workspace/${t}/password`;
  function u() {
    return f(e).get();
  }
  function r(p) {
    return f(e).post({ password: p });
  }
  function s(p) {
    return f(e).put({ password: p });
  }
  return { get: u, post: r, put: s };
}
function rt(o, c, n) {
  const t = `${o}${c}/${n}/template/dataspaces`;
  function e() {
    return f(t).get();
  }
  function u(r, s, p) {
    return f(t).post({ name: r, description: s, language: p });
  }
  return { get: e, post: u };
}
function st(o, c, n, t) {
  const e = `${o}${c}/${n}/template/dataspace/${t}`;
  function u() {
    return f(e).get();
  }
  function r(p) {
    return f(e).put(p);
  }
  function s() {
    return f(e).del();
  }
  return { get: u, put: r, del: s };
}
function T(o, c, n) {
  m(o, () => {
    o.send(
      JSON.stringify({
        type: "send",
        topic: c,
        payload: n
      })
    );
  });
}
function $(o, c) {
  m(o, () => {
    o.send(
      JSON.stringify({
        type: "subscribe",
        topic: c
      })
    );
  });
}
function l(o, c) {
  m(o, () => {
    o.send(
      JSON.stringify({
        type: "unsubscribe",
        topic: c
      })
    );
  });
}
function m(o, c) {
  if (o.readyState != WebSocket.OPEN) {
    const n = () => {
      o.removeEventListener("open", n), c();
    };
    o.addEventListener("open", n);
  } else
    c();
}
function ft(o, c) {
  const n = "/domains";
  function t(u) {
    $(o, n), c[n] = u;
  }
  function e() {
    l(o, n), delete c[n];
  }
  return { on: t, off: e };
}
function pt(o, c, n) {
  const t = `/${c}`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function it(o, c, n) {
  const t = `/${c}/graph`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function at(o, c, n) {
  const t = `/${c}/concept/dataobjects`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function $t(o, c, n, t) {
  const e = `/${c}/concept/dataobject/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function lt(o, c, n) {
  const t = `/${c}/concept/attributes`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function gt(o, c, n, t) {
  const e = `/${c}/concept/attribute/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function bt(o, c, n) {
  const t = `/${c}/concept/events`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function kt(o, c, n, t) {
  const e = `/${c}/concept/event/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function Tt(o, c, n) {
  const t = `/${c}/concept/tasks`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function vt(o, c, n, t) {
  const e = `/${c}/concept/task/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function yt(o, c, n) {
  const t = `/${c}/template/dataspaces`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function ht(o, c, n, t) {
  const e = `/${c}/template/dataspaces/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function mt(o, c, n) {
  const t = `/${c}/template/processes`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function Pt(o, c, n, t) {
  const e = `/${c}/template/process/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function jt(o, c, n) {
  const t = `/${c}/template/workspaces`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function Ct(o, c, n, t) {
  const e = `/${c}/template/workspaces/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function Et(o, c, n) {
  const t = `/${c}/template/dataobjects`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function Dt(o, c, n, t) {
  const e = `/${c}/template/dataobject/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function St(o, c, n) {
  const t = `/${c}/template/events`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function Wt(o, c, n, t) {
  const e = `/${c}/template/event/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function Nt(o, c, n) {
  const t = `/${c}/template/tasks`;
  function e(r) {
    $(o, t), n[t] = r;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function Ot(o, c, n, t) {
  const e = `/${c}/template/task/${n}`;
  function u(s) {
    $(o, e), t[e] = s;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { on: u, off: r };
}
function At(o, c, n, t) {
  const e = `/${c}/template/process/${n}/livePosition`;
  function u(p) {
    T(o, e, p);
  }
  function r(p) {
    $(o, e), t[e] = p;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { send: u, on: r, off: s };
}
function Lt(o, c, n, t) {
  const e = `/${c}/template/process/${n}/nodePosition`;
  function u(p) {
    T(o, e, p);
  }
  function r(p) {
    $(o, e), t[e] = p;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { send: u, on: r, off: s };
}
function Jt(o, c, n, t) {
  const e = `/${c}/template/workspace/${n}/livePosition`;
  function u(p) {
    T(o, e, p);
  }
  function r(p) {
    $(o, e), t[e] = p;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { send: u, on: r, off: s };
}
function Ut(o, c, n, t) {
  const e = `/${c}/template/workspace/${n}/nodePosition`;
  function u(p) {
    T(o, e, p);
  }
  function r(p) {
    $(o, e), t[e] = p;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { send: u, on: r, off: s };
}
let i;
const a = {};
let P;
const j = [];
let y = !1;
function C(o, c) {
  i || (i = new WebSocket(`${o}${c}`)), i.onopen = () => {
    y && (y = !1, j.forEach((n) => n())), setTimeout(() => Object.keys(a).forEach((n) => $(i, n)), 100), P = setInterval(() => {
      i.readyState === WebSocket.OPEN && i.send(JSON.stringify({ type: "keepalive" }));
    }, 1e4);
  }, i.onclose = () => {
    clearInterval(P), y = !0, setTimeout(() => {
      i = new WebSocket(`${o}${c}`), C(o, c);
    }, 1e3);
  }, i.onmessage = (n) => {
    var r;
    const t = JSON.parse(n.data), e = t.topic, u = t.payload;
    (r = a[e]) == null || r.call(a, u);
  };
}
function Ft(o, c) {
  return i || (i = new WebSocket(`${o}${c}`)), C(o, c), {
    ws: i,
    onDisconnect: (n) => {
      i.addEventListener("close", n);
    },
    onReconnect: (n) => {
      j.push(n);
    },
    domains: () => ft(i, a),
    domain: (n) => ({
      ...pt(i, n, a),
      graph: () => it(i, n, a),
      concept: () => ({
        dataobjects: () => at(i, n, a),
        dataobject: (t) => $t(i, n, t, a),
        attributes: () => lt(i, n, a),
        attribute: (t) => gt(i, n, t, a),
        events: () => bt(i, n, a),
        event: (t) => kt(i, n, t, a),
        tasks: () => Tt(i, n, a),
        task: (t) => vt(i, n, t, a)
      }),
      template: () => ({
        dataobjects: () => Et(i, n, a),
        dataobject: (t) => Dt(i, n, t, a),
        events: () => St(i, n, a),
        event: (t) => Wt(i, n, t, a),
        dataspaces: () => yt(i, n, a),
        dataspace: (t) => ht(i, n, t, a),
        processes: () => mt(i, n, a),
        process: (t) => ({
          ...Pt(i, n, t, a),
          livePosition: () => At(i, n, t, a),
          nodePosition: () => Lt(i, n, t, a)
        }),
        workspaces: () => jt(i, n, a),
        workspace: (t) => ({
          ...Ct(i, n, t, a),
          livePosition: () => Jt(i, n, t, a),
          nodePosition: () => Ut(i, n, t, a)
        }),
        tasks: () => Nt(i, n, a),
        task: (t) => Ot(i, n, t, a)
      })
    })
  };
}
let h;
function Gt(o = {}) {
  if (!h) {
    const t = new URL(k.host || window.location.href), u = `${t.protocol == "http:" ? "ws" : "wss"}://${t.host}`;
    h = Ft(u, "/api/v1.0");
  }
  const c = o.host || k.host, n = o.host || k.basePath;
  return {
    socket: () => h,
    domains: () => W(c, n),
    domain: (t) => ({
      ...S(c, n, t),
      account: () => D(c, n, t),
      searchUsers: () => O(c, n, t),
      members: () => N(c, n, t),
      graphs: () => A(c, n, t),
      descriptor: () => ({
        datatypes: () => L(c, n, t),
        datatype: (e) => J(c, n, t, e)
      }),
      concept: () => ({
        dataobjects: () => q(c, n, t),
        dataobject: (e) => x(c, n, t, e),
        attributes: () => U(c, n, t),
        attribute: (e) => F(c, n, t, e),
        fragments: () => z(c, n, t),
        fragment: (e) => B(c, n, t, e),
        functions: () => M(c, n, t),
        function: (e) => K(c, n, t, e),
        emitters: () => Q(c, n, t),
        emitter: (e) => V(c, n, t, e),
        events: () => G(c, n, t),
        event: (e) => H(c, n, t, e),
        tasks: () => R(c, n, t),
        task: (e) => d(c, n, t, e)
      }),
      template: () => ({
        dataobjects: () => w(c, n, t),
        dataobject: (e) => I(c, n, t, e),
        events: () => X(c, n, t),
        event: (e) => Y(c, n, t, e),
        dataspaces: () => rt(c, n, t),
        dataspace: (e) => st(c, n, t, e),
        processes: () => tt(c, n, t),
        process: (e) => ({
          ...et(c, n, t, e),
          password: () => nt(c, n, t, e)
        }),
        workspaces: () => ot(c, n, t),
        workspace: (e) => ({
          ...ct(c, n, t, e),
          password: () => ut(c, n, t, e)
        }),
        tasks: () => Z(c, n, t),
        task: (e) => _(c, n, t, e)
      })
    })
  };
}
export {
  Gt as api,
  k as apiConfig
};
